import React from "react";
import PropTypes from "prop-types";
import $ from 'jquery';
import {connect} from "react-redux";

import DemoPoint from "./demoPoint";
import Config from "../../../config";

class DemoPoints extends React.Component {

  static propTypes = {
    layoutFeatures: PropTypes.array.isRequired,
    layoutType: PropTypes.number.isRequired,
    canvasId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      points: [],
      currentLayoutType: null,
      dimensions: {
        width: this.props.canvasDimensions.width,
        height: this.props.canvasDimensions.height
      },
    }
  }

  componentDidMount() {
    this.setPoints(this.props);
    this.handleResize();
    $(window).on('resize', this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.currentLayoutType !== nextProps.layoutType) {
      this.setPoints(nextProps);
    }
  }

  componentWillUnmount() {
    $(window).off('resize', this.handleResize);
  }

  setPoints = (nextProps) => {
    const points = [];
    nextProps.layoutFeatures.forEach((parentGroup) => {
      // console.log("parentGroup", parentGroup);
      switch (document.kvConfig.visualizerType) {
        case "Bathroom":
        case "BV": {
          if (parentGroup.partName === "Walls") {
            const pointB = this.getBathroomPointPositionByPartName("Wall B");
            const pointC = this.getBathroomPointPositionByPartName("Wall C");
            points.push(pointB, pointC);
          } else if (parentGroup.partName === "Vanity") {
            const vanity = this.getBathroomPointPositionByPartName("Vanity");
            const mirror = this.getBathroomPointPositionByPartName("Mirror");
            points.push(vanity, mirror);
          } else if (!(nextProps.layoutType === 0 &&
            (parentGroup.partName === "Window" || parentGroup.partName === "Bathtub"))) {
            const point = this.getBathroomPointPositionByPartName(parentGroup.partName, nextProps);
            if (point.left || point.top) {
              points.push(point);
            }
          }
          break;
        }
        case "bvScene": {
          const bvScenePoints = [
            {
              partId: "shower_head",
              left: 925,
              top: 400,
            },
            {
              partId: "toilet",
              left: 380,
              top: 820,
            },
            {
              partId: "vanity_sink",
              left: 530,
              top: 670,
            },
            {
              partId: "bathtub_body",
              left: 1520,
              top: 760,
            },
          ]
          parentGroup.relatedItems.forEach(relItem => {
            const relPoint = bvScenePoints.find(bvScenePoint => {
              return bvScenePoint.partId === relItem.partId && !relItem.disabled
            })
            if (relPoint) {
              points.push(relPoint)
            }
          });
          break;
        }
        case "Kitchen":
        case "KV": {
          switch (parentGroup.partName) {
            case "Walls": {
              points.push(
                this.getKitchenPointPosition("left_wall"),
                this.getKitchenPointPosition("right_wall"),
                this.getKitchenPointPosition("ceiling")
              );
              break;
            }
            case "Appliances": {
              points.push(
                this.getKitchenPointPosition("hood"),
                this.getKitchenPointPosition("range"),
                this.getKitchenPointPosition("fridge"),
                this.getKitchenPointPosition("dishwasher")
              );
              break;
            }
            case "Countertop": {
              points.push(
                this.getKitchenPointPosition("countertop3"),
                this.getKitchenPointPosition("sink1")
              );
              break;
            }
            case "Cabinet": {
              points.push(
                this.getKitchenPointPosition("top_cabinet"),
                this.getKitchenPointPosition("top_cabinet2"),
                this.getKitchenPointPosition("bottom_cabinet")
              );
              break;
            }
            case "CenterIsland": {
              points.push(
                this.getKitchenPointPosition("center_island_counterop"),
                this.getKitchenPointPosition("center_island_cabinet"),
                this.getKitchenPointPosition("center_island_chairs")
              );
              break;
            }
          }
          break;
        }
      }
    });
    this.setState({
      points,
      currentLayoutType: nextProps.layoutType
    });
  };

  handleResize = () => {
    const canvas = $(document.getElementById(this.props.canvasId));
    this.setState({
      dimensions: {
        width: canvas.width(),
        height: canvas.height()
      }
    });
  };

  getBathroomPointPositionByPartName = (partName, nextProps = this.props) => {
    switch (partName) {
      case "Vanity":
        return {
          left: 356,
          top: 720,
        };
      case "Mirror":
        return {
          left: 318,
          top: 422,
        };
      case "Toilet":
        return {
          left: 625,
          top: 740,
        };
      case "Floor":
        return {
          left: nextProps.layoutType === 0 ? 762 : 990,
          top: 990,
        };
      case "Window":
        return {
          left: 1290,
          top: 475,
        };
      case "Bathtub":
        return {
          left: 1450,
          top: 915,
        };
      case "Shower":
        return {
          left: 930,
          top: 600,
        };
      case "Wall B":
        return {
          left: 600,
          top: 440,
        };
      case "Wall C":
        return {
          left: 1480,
          top: 580,
        };
      default :
        return {
          left: 0,
          top: 0,
        }
    }
  };

  getKitchenPointPosition = (partId, nextProps = this.props) => {
    nextProps === 12 ? null : false;
    switch (partId) {
      case "left_wall":
        return {
          left: 450,
          top: 550,
        };
      case "right_wall":
        return {
          left: 1050,
          top: 550,
        };
      case "ceiling":
        return {
          left: 740,
          top: 120,
        };
      case "hood":
        return {
          left: 1020,
          top: 400,
        };
      case "range":
        return {
          left: 1000,
          top: 680,
        };
      case "fridge":
        return {
          left: 175,
          top: 600,
        };
      case "dishwasher":
        return {
          left: 720,
          top: 655,
        };
      case "top_cabinet":
        return {
          left: 740,
          top: 410,
        };
      case "top_cabinet2":
        return {
          left: 1380,
          top: 370,
        };
      case "bottom_cabinet":
        return {
          left: 1260,
          top: 780,
        };
      case "center_island_counterop":
        return {
          left: 600,
          top: 750,
        };
      case "center_island_cabinet":
        return {
          left: 1040,
          top: 890,
        };
      case "center_island_chairs":
        return {
          left: 390,
          top: 870,
        };
      case "sink1":
        return {
          left: 1430,
          top: 670,
        };
      case "countertop3":
        return {
          left: 1450,
          top: 930,
        };
      default :
        return {
          left: 0,
          top: 0,
        }
    }
  };

  render() {
    const dashboardFramed = Config.isVisualizerManagement();
    return this.state.dimensions.width && this.state.dimensions.height && !dashboardFramed ? (
      <div className="demo-points">
        {this.state.points.map((point, index) => {
          const pointResponsive = {
            left: point.left * (this.state.dimensions.width / this.props.canvasDimensions.width),
            top: point.top * (this.state.dimensions.height / this.props.canvasDimensions.height),
          };
          return <DemoPoint key={"demopoint"+index} point={pointResponsive}/>
        })}
      </div>
    ) : null
  }
}

const mapStateToProps = (store) => {
  const {canvasDimensions} = store.bathroomVisualizerState;
  return {
    canvasDimensions,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DemoPoints)
